import { render, staticRenderFns } from "./customer-form-dialog.vue?vue&type=template&id=61d9e8bc"
import script from "./customer-form-dialog.vue?vue&type=script&lang=js"
export * from "./customer-form-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports